import React, { useState, useEffect } from 'react';
import Tools from '../../Tools';
import Popover from '../../ui/Popover';


const DocsClaroDicom = (props) => {

    const [selectedAllDocs, setSelectedAllDocs] = useState(true);
    const [loading, setLoading] = useState({ client: false, campaign: false, tasks: false, documents: false, patent: false });
    const [error, setError] = useState(false);
    const [documentId, setDocumentId] = useState(null);

    const toggleAllDebts = () => {
        setSelectedAllDocs(!selectedAllDocs); //variable to toggle
        if (selectedAllDocs) {
            props.documents.forEach(d => { d.selected = false; });
            props.setDebtFn(0);
        } else {
            props.documents.forEach(d => { d.selected = true; });
            props.setDebtFn(props.documents.reduce((a, doc) => { return a + Number(doc.deuda_emitida)}, 0));
        }
    }

    const selectDebt = (event, doc) => {
        if (!event.target.checked) {
            doc.selected = false;
            props.setDebtFn(props.debt - Number(event.target.value));
        } else {
            doc.selected = true;
            props.setDebtFn(props.debt + Number(event.target.value));
        }
    }

    useEffect(() => {
        const totalDebt = props.documents.reduce((a, doc) => { return a + Number(doc.deuda_emitida); }, 0);
        props.setDebtFn(totalDebt);
    }, [props.documents]);

    return (
        <table className="fullWidth">
            <thead>
                <tr>
                    <th><input type="checkbox" onChange={toggleAllDebts} defaultChecked={true} /> &nbsp; Cedente</th>
                    <th className='center'>cuenta</th>
                    <th className='right'>num docto</th>
                    <th className='right'>total cuota</th>
                    <th className='center'>cuota pagada</th>
                    <th className='right'>deuda equipo</th>
                    <th className='right'>deuda emitida</th>
                    <th className='right'>dscto</th>
                </tr>
            </thead>
            <tbody>
                {props.documents.map((doc, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                <label className="forCheckbox">
                                    <input type="checkbox" name={'ckeck' + index} value={doc.deuda_emitida} onChange={(e) => selectDebt(e, doc)} checked={doc.selected} defaultChecked={true} />
                                    CLARO DICOM 
                                </label>
                            </td>
                            <td className='center'>{doc.cuenta}</td>
                            <td className='right'>{doc.num_documento}</td>
                            <td className='right'>{Tools.fmtClNumber(doc.total_cuota)}</td>
                            <td className='center'>{doc.cuota_pagada}</td>
                            <td className='right'>{Tools.fmtClAmmount(doc.deuda_equipo)}</td>
                            <td className='right'>{Tools.fmtClAmmount(doc.deuda_emitida)}</td>
                            <td className='right'>{doc.dscto}%</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );

}

export default DocsClaroDicom;